import { useEffect, useState } from 'react';
import { QUESTION_TYPES } from '../../../../constants/appConstants';
import SolveQuestionDialog from '../../../../components/QuesAndAns/SolveQuestionDialog';
import * as React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import SuccessDialog from '../../../../components/dialogs/SuccessDialog';

export default function Modal({ isCorrect, solution, turn }) {
  const [solveQuestion, setSolveQuestion] = useState(true)
  const [open, setOpen] = React.useState(false);

  useEffect(() => {
    setOpen(isCorrect)
  }, [isCorrect])
  
  return (
    <div >
      {isCorrect && (
       <SuccessDialog />
      )}
      {!isCorrect && (
        <div>
          <SolveQuestionDialog settings={{solveQuestion: solveQuestion}} initialSolve={true} 
          questionType={QUESTION_TYPES.WORDLE} 
          handleSubmitVote={() => {
            setSolveQuestion(false)
          }} 
          setSolvingMethod={() => {}}/>
        </div>
      )}
    </div>
  )
}
